module.exports = __webpack_public_path__ + "./images/3f036b2bedc145c7e097cf375b16d64a.webp";